import type { SubscriptionInfo } from "./api";

/**
 * Subscription date for display. Spells the month out because the numeric
 * locale format is ambiguous across countries — "8/2/2026" is 2 August to a US
 * reader and 8 February to a European one. Returns null for missing or
 * unparseable input so callers render a dash instead of "Invalid Date".
 */
export function formatPlanDate(
  iso: string | null | undefined,
  lang: "en" | "ru",
): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(lang === "ru" ? "ru-RU" : "en-US", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

/**
 * Human-readable name of the plan the user is on, for the sidebar badge and the
 * Payments card. Prefers the backend's `display_name`; falls back to the tier
 * code in caps ("PRO") when it is missing or blank. Returns null when there is
 * no plan — callers render a "pick a plan" affordance instead.
 */
export function planLabel(
  subscription: SubscriptionInfo | null | undefined,
): string | null {
  const plan = subscription?.plan;
  if (!plan) return null;
  const displayName = plan.display_name?.trim();
  if (displayName) return displayName;
  const tier = plan.plan_tier?.trim();
  return tier ? tier.toUpperCase() : null;
}
